import {ButtonConfig} from 'app/shared/models/buttonConfig.model';

export class ModalConfig {
    public body?: string;
    public buttons?: Array<ButtonConfig>;
    public closeButton?: boolean;
    public closeButtonSize?: 'medium' | 'large';
    public size?: 'small' | 'medium' | 'large';
    public title?: string;
    public bodyColor?: string;
    public noPadding?: boolean;
    public closeButtonColor?: 'primary' | 'secondary';

    constructor() {
        this.body = '';
        this.closeButton = false;
        this.size = 'medium';
        this.title = ''
    }
}
